import { ExtendedObservation } from '@seen/core/models/observation'
import { recordedObservationAnswers } from '@seen/core/observationReferences'
import { referenceStringToId } from '@seen/core/references'
import type { ObservationNodeAttributes } from '#src/components/rich-text-editor/ObservationNode/types.ts'
import { useRead } from '#src/hooks/useRead.ts'
import { useSearch } from '#src/hooks/useSearch.ts'

// The records a node's Clear would remove: its own, or each answer of a
// multi-select, leaving out any already entered in error. Read only while
// `enabled` (the node can be cleared from here).
export function useClearableRecords(
  attributes: ObservationNodeAttributes,
  enabled: boolean
): ExtendedObservation[] {
  const { data: observation } = useRead(
    ExtendedObservation,
    enabled && !attributes.repeats ? attributes.reference : null
  )
  const answerIds = recordedObservationAnswers(attributes.references).map(
    (answer) => referenceStringToId(answer.reference)
  )
  const { data: answerObservations } = useSearch(
    ExtendedObservation,
    enabled && answerIds.length > 0 ? { _id: answerIds.join(',') } : undefined,
    { silentErrors: true }
  )
  if (attributes.repeats) {
    return (answerObservations ?? []).filter(
      (recorded) => !recorded.isEnteredInError
    )
  }
  return observation && !observation.isEnteredInError ? [observation] : []
}
